<div fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row">
    <h2>Dodaj saldo</h2>
  </div>

  <div  fxFlex="100">

    <app-dict-partners label="Partner" [control]="partnerControl"  [required]="false"></app-dict-partners>

  </div>


  <div fxFlex="100" *ngIf="!partnerControl.value">

    <app-dict-ofwcas label="OFWCA" [control]="ofwcaControl"  [required]="false" ></app-dict-ofwcas>

  </div>


  <div fxFlex="100" *ngIf="partnerControl.value">

    <app-dict-ofwcas label="OFWCA" [control]="ofwcaControl"  [required]="false" [filterPartner]="partnerControl.value" ></app-dict-ofwcas>

  </div>

  <div  fxFlex="100" *ngIf="!partnerControl.value && ofwcaControl.value  && partnerOfwcaId !== null ">


    <app-partner-facility-select label="Placówka" [control]="partnerFacilityControl" [multiple]="false" [required]="false"
                                 [partnerIdString]="partnerOfwcaId"></app-partner-facility-select>

  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <button
      mat-raised-button (click)="sendForm()" color="primary"
      [class.spinner]="processingRequest" [disabled]="processingRequest"
    >Zapisz</button>
    <button (click)="closeDialog($event)" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
